module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/2@2x_5e06fdd852ca5d8d45f8b4a5d790e8fb.png";